import type { ExcelGridRow } from "../../shared/excel-grid/models/excel-grid.models";
import type {
  AdminCrewReportRunningVesselCrewReport,
  AdminCrewReportRunningVesselGridRow,
  AdminCrewReportVesselCrewMember,
  AdminCrewReportVesselOption,
} from "../models/admin-crew-report.models";
import {
  ADMIN_CREW_REPORT_MONTHS_ON_BOARD_BUCKET_LABELS,
  ADMIN_CREW_REPORT_REQUEST_STATUS_LABELS,
} from "./admin-crew-report.constants";

export function toAdminCrewReportRunningVesselGridRows(
  vessels: AdminCrewReportRunningVesselCrewReport[],
  canRequestReports: boolean,
): AdminCrewReportRunningVesselGridRow[] {
  return vessels.map((vessel) => ({
    gridRowId: vessel.imoNumber,
    bulkRequest: "",
    report: vessel.hasCrewReport ? "Show Report" : canRequestReports ? "Request Report" : "No report",
    requestStatus: ADMIN_CREW_REPORT_REQUEST_STATUS_LABELS[vessel.requestStatus],
    vesselName: vessel.vesselName,
    imoNumber: vessel.imoNumber,
    desk: vessel.desk ?? "",
    vesselEmail: vessel.vesselEmail ?? "",
    reportDate: formatAdminCrewReportDate(vessel.reportReceivedAt),
    maxPeriod: vessel.maxPeriodMonths === null ? "" : vessel.maxPeriodMonths.toFixed(1),
    above11Months: formatAdminCrewReportBoolean(vessel.hasAbove11Months),
    category: vessel.category ? ADMIN_CREW_REPORT_MONTHS_ON_BOARD_BUCKET_LABELS[vessel.category] : "",
    hasOverdue: formatAdminCrewReportBoolean(vessel.hasOverdue),
    hasWomen: formatAdminCrewReportBoolean(vessel.hasWomen),
    owner: vessel.owner ?? "",
    technicalManager: vessel.technicalManager ?? "",
    registeredOwner: vessel.registeredOwner ?? "",
    operator: vessel.operator ?? "",
    beneficialOwner: vessel.beneficialOwner ?? "",
  }));
}

export function toAdminCrewReportViewGridRows(
  rows: AdminCrewReportVesselCrewMember[],
  imoNumber: string,
): ExcelGridRow[] {
  return rows.map((row) => ({
    gridRowId: `${imoNumber}:${row.crewRowNumber}`,
    crewRowNumber: row.crewRowNumber,
    gender: row.gender ?? "",
    nationality: row.nationality ?? "",
    designationRank: row.designationRank ?? "",
    contractDurationMonths: row.contractDurationMonths ?? "",
    signOnDate: formatAdminCrewReportDate(row.signOnDate),
    changePlannedDate: formatAdminCrewReportDate(row.changePlannedDate),
    monthsOnBoard: row.monthsOnBoard === null ? "" : row.monthsOnBoard.toFixed(1),
    isLongTenure: row.isLongTenure,
    overdue: row.isOverdue ? "Yes" : "No",
  }));
}

export function toAdminCrewReportVesselOption(
  vessel: AdminCrewReportRunningVesselCrewReport,
): AdminCrewReportVesselOption {
  return {
    vesselName: vessel.vesselName,
    vesselCode: vessel.vesselCode,
    imoNumber: vessel.imoNumber,
    vesselType: vessel.desk,
  };
}

export function formatAdminCrewReportDate(value: string | null | undefined): string {
  if (!value) return "";
  const date = /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(`${value}T00:00:00.000Z`) : new Date(value);
  if (!Number.isFinite(date.getTime())) return "";
  return `${String(date.getUTCMonth() + 1).padStart(2, "0")}/${String(date.getUTCDate()).padStart(2, "0")}/${date.getUTCFullYear()}`;
}

function formatAdminCrewReportBoolean(value: boolean | null): string {
  if (value === null) return "";
  return value ? "Yes" : "No";
}
